import { render, staticRenderFns } from "./map1.vue?vue&type=template&id=3887b69a&"
import script from "./map1.vue?vue&type=script&lang=js&"
export * from "./map1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports